// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__3O5Z7","pipe":"Footer_pipe__3OVN0","registered":"Footer_registered__29FEW","text":"Footer_text__Xa0Ue"};